/**
 * 角色管理
 * 角色管理
 *
 * OpenAPI spec version: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import ApiClient from '../../ApiClient';




  /**
   * The RoleCreateForm model module.
   * @module role/model/RoleCreateForm
   * @version 0.2.0
   */

  /**
   * Constructs a new <code>RoleCreateForm</code>.
   * @alias module:role/model/RoleCreateForm
   * @class
   */
  var exports = function() {
    var _this = this;




  };

  /**
   * Constructs a <code>RoleCreateForm</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:role/model/RoleCreateForm} obj Optional instance to populate.
   * @return {module:role/model/RoleCreateForm} The populated <code>RoleCreateForm</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (Object.prototype.hasOwnProperty.call(data, 'name')) {
        obj['name'] = ApiClient.convertToType(data['name'], 'String');
      }
      if (Object.prototype.hasOwnProperty.call(data, 'permissions')) {
        obj['permissions'] = ApiClient.convertToType(data['permissions'], ['Integer']);
      }
      if (Object.prototype.hasOwnProperty.call(data, 'remark')) {
        obj['remark'] = ApiClient.convertToType(data['remark'], 'String');
      }
    }
    return obj;
  }

  /**
   * 角色名
   * @member {String} name
   */
  exports.prototype['name'] = undefined;
  /**
   * 权限列表
   * @member {Array.<Integer>} permissions
   */
  exports.prototype['permissions'] = undefined;
  /**
   * 备注
   * @member {String} remark
   */
  exports.prototype['remark'] = undefined;



  export default exports;
;


